// extracted by mini-css-extract-plugin
export default {"page":"Payments_page__ZV9oL","container":"Payments_container__vS9Rl","header":"Payments_header__V1p9s","bar":"Payments_bar__oXD9Y","table":"Payments_table__XcHm1"};